import { HeaderVariant } from 'app/layouts/Layout'
import React, { createContext, ReactNode } from 'react'

export type LayoutContext = {
  layoutData: LayoutData
  updateLayoutData: (layoutData: LayoutData) => void
}

export type LayoutData = {
  title?: string
  subTitle?: string
  headerVariant?: HeaderVariant
}

export const LayoutContext = createContext<LayoutContext | null>(null)

type Props = {
  children: ReactNode
}

export const LayoutProvider = ({ children }: Props): JSX.Element => {
  const [layoutData, setLayoutData] = React.useState<LayoutData>({})

  const updateLayoutData = React.useCallback((layoutData: LayoutData) => {
    setLayoutData(layoutData)
  }, [])

  const value = React.useMemo(
    () => ({ layoutData, updateLayoutData }),
    [layoutData, updateLayoutData]
  )

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  )
}

export function useLayout(): LayoutContext {
  const context = React.useContext(LayoutContext)
  if (!context) {
    throw new Error(`useLayout must be used within a LayoutProvider`)
  }
  return context
}
